import * as React from 'react';

const Smartphone16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.5 2.5v11h-7v-11zm.3-2.5H4.21C3.542 0 3 .52 3 1.16v13.7c0 .63.532 1.14 1.189 1.14h7.622c.657 0 1.189-.51 1.189-1.14V1.16C13 .52 12.458 0 11.79 0z"
  }
));
Smartphone16.Size = 16;
Smartphone16.Title = "Smartphone";

export { Smartphone16 as default };
